import FirstForm from './FirstForm.jsx';
import Initial from './Initial';
import Welcome from './Welcome';
import Documents from './Documents';
import Contract from './Contract';
import SignatureNeutral from './SignatureNeutral';
import SignatureSpecial from './SignatureSpecial';
import Form from './Form';
import End from './End';

const steps = [
  Initial,
  FirstForm,
  Welcome,
  Contract,
  Documents,
  SignatureNeutral,
  SignatureSpecial,
  Form,
  End
];

export default steps;
